import EditProduct from "./edit-product.container";

export default EditProduct;
